import { ConsultantFilterState } from "../utils/consultant-filter-state";
import { aoeSectionInitialValues } from "@consultants/ConsultantSearch/professions/aoe_section/utils";
import { expOnlyInitialValue } from "@consultants/ConsultantSearch/professions/exp_only/utils";
import { psykologInitialValues } from "@consultants/ConsultantSearch/professions/psykolog/utils";
import { radiographerInitialValues } from "@consultants/ConsultantSearch/professions/radiographer/utils";
import { socionomInitialValues } from "@consultants/ConsultantSearch/professions/socionom";
import { sskInitialValues } from "@consultants/ConsultantSearch/professions/ssk";
import { teacherInitialValues } from "@consultants/ConsultantSearch/professions/teacher/utils";
import {
  ConsultantTableColumns,
  SelectType,
  ConsultantStatus,
  SortOrder
} from "@bonliva-crm/shared";

export function useInitialValues(): {
  emptyValues: ConsultantFilterState;
  initialValues: ConsultantFilterState;
} {
  const emptyValues = {
    text: "",
    sort: {
      sortBy: ConsultantTableColumns.Name,
      sortOrder: SortOrder.Asc
    },
    availableForWorkInCountries: [],
    location: { zipOrCity: "", klm: "20" },
    responsiblePerson: [],
    lastContact: {
      dates: { from: null, to: null },
      myActivity: null,
      type: null,
      selectType: SelectType.AND
    },
    ageRange: {
      from: null,
      to: null
    },
    availability: {
      from: null,
      to: null
    },
    customerIds: [],
    initialContact: [],
    callListIds: [],
    alphabetFilter: [],
    initialsLastName: [],
    workshifts: [],
    regions: [],
    bookingStatusOption: null,
    bookingStatus: null,
    competitors: [],
    fitness: null,
    fullTextSearch: false,
    gdprIntegrationPolicy: null,
    gdprMarketing: null,
    gdprJobMailingEmail: null,
    gdprJobMailingSms: null,
    hasDrivingLicence: "none" as const,
    hasEmail: null,
    hasLegalPersonType: null,
    hasPhone: null,
    hprNumber: null,
    knownSystems: [],
    leadStatus: null,
    legalBasis: null,
    nationalQualification: null,
    qualification: null,
    tags: [],
    qualityCheck: null,
    workedInNorway: null,
    simpleProfession: {
      professions: [],
      areaOfExpertises: []
    },
    profession: {
      professions: [] as string[],
      doctor: aoeSectionInitialValues,
      expOnly: expOnlyInitialValue,
      psykolog: psykologInitialValues,
      radiographer: radiographerInitialValues,
      socialWorkerForm: socionomInitialValues,
      sskForm: sskInitialValues,
      teacherForm: teacherInitialValues
    },
    wagesRange: { from: null, to: null },
    nextContact: { from: null, to: null },
    pipelineStatus: [],
    status: [ConsultantStatus.Active],
    onlyFavourites: false
  };

  const initialValues = {
    ...emptyValues,
    availableForWorkInCountries: ["Sweden"]
  };

  return {
    emptyValues,
    initialValues
  };
}
